import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

const industries = [
    {
        title: "Education & Edtech",
        desc: "Engage students and simplify admissions.",
        href: "/industries/education",
        icon: "🎓",
    },
    {
        title: "Healthcare",
        desc: "Streamline patient communication & appointments.",
        href: "/industries/healthcare",
        icon: "🩺",
    },
    {
        title: "Finance",
        desc: "Automate reminders, payments & queries.",
        href: "/industries/finance",
        icon: "💳",
    },
    {
        title: "E-commerce",
        desc: "Order tracking, notifications & support.",
        href: "/industries/ecommerce",
        icon: "🛒",
    },
    {
        title: "Retail",
        desc: "Boost sales with personalized WhatsApp offers.",
        href: "/industries/retail",
        icon: "🛍️",
    },
    {
        title: "Travel & Tourism",
        desc: "Bookings, itineraries & real-time trip updates.",
        href: "/industries/travel",
        icon: "🧳",
    },
    {
        title: "Hospitality",
        desc: "Booking confirmations & guest support.",
        href: "/industries/hospitality",
        icon: "🏨",
    },
    {
        title: "Logistics",
        desc: "Delivery notifications & customer support.",
        href: "/industries/logistics",
        icon: "🚚",
    },
    {
        title: "Real Estate",
        desc: "Lead capture, site visits & property details.",
        href: "/industries/real-estate",
        icon: "🏠",
    },
    {
        title: "Insurance",
        desc: "Policy info, claims & renewals on WhatsApp.",
        href: "/industries/insurance",
        icon: "🛡️",
    },
    {
        title: "Media & Entertainment",
        desc: "Promote events, manage tickets, engage fans.",
        href: "/industries/media",
        icon: "🎬",
    },
    {
        title: "Government Services",
        desc: "Deliver citizen services & updates in chat.",
        href: "/industries/government",
        icon: "🏛️",
    },
];

const IndustriesData = () => {
    const [open, setOpen] = useState(false);
    const timerRef = useRef(null);

    const handleEnter = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setOpen(true);
    };

    const handleLeave = () => {
        timerRef.current = setTimeout(() => setOpen(false), 180);
    };

    const cardBg = "linear-gradient(135deg, #F4F7FC 0%, #DDEAFF 100%)";

    const iconChip = {
        flexShrink: 0,
        width: 48,
        height: 48,
        borderRadius: 10,
        background: "rgba(255,255,255,0.65)",
        border: "1px solid rgba(255,255,255,0.7)",
        display: "grid",
        placeItems: "center",
        backdropFilter: "saturate(180%) blur(8px)",
        WebkitBackdropFilter: "saturate(180%) blur(8px)",
        overflow: "hidden",
        fontSize: 22,
    };

    return (
        <div
            className="mx-3 position-relative"
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            style={{ display: "inline-block" }}
        >
            {/* Trigger */}
            <span
                className="text-dark fw-normal"
                style={{ fontFamily: "Poppins", fontSize: 18, cursor: "pointer" }}
                role="button"
                tabIndex={0}
            >
                Industries
            </span>

            {/* Dropdown */}
            <div
                className={`vs-industries-dropdown ${open ? "show" : ""}`}
                style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    marginTop: 10,
                    background: "#fff",
                    borderRadius: 12,
                    boxShadow: "0 12px 32px rgba(16,24,40,0.12)",
                    padding: 16,
                    width: "clamp(320px, 60vw, 860px)",
                    zIndex: 1000,
                }}
            >
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(260px, 1fr))",
                        gap: 16,
                    }}
                >
                    {industries.map((item) => (
                        <Link
                            key={item.title}
                            to={item.href}
                            className="text-decoration-none"
                            style={{
                                background: cardBg,
                                borderRadius: 12,
                                padding: "14px 16px",
                                display: "flex",
                                alignItems: "center",
                                gap: 14,
                                transition: "transform .15s ease, box-shadow .15s ease",
                                color: "#0f172a",
                            }}
                        >
                            <span style={iconChip}>{item.icon}</span>

                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                    style={{
                                        fontSize: 16,
                                        fontWeight: 700,
                                        marginBottom: 4,
                                        color: "#161a22ff",
                                    }}
                                >
                                    {item.title}
                                </div>

                                <div
                                    style={{
                                        fontSize: 14,
                                        lineHeight: 1.2,
                                        color: "#475569",
                                    }}
                                >
                                    {item.desc}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            <style>{`
        .vs-industries-dropdown {
          pointer-events: none;
          opacity: 0;
          transform: translateY(8px);
          transition: opacity .2s ease, transform .2s ease;
        }
        .vs-industries-dropdown.show {
          pointer-events: auto;
          opacity: 1;
          transform: translateY(0);
        }
        .vs-industries-dropdown a:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 18px rgba(0,0,0,0.08);
        }
      `}</style>
        </div>
    );
};

export default IndustriesData;
